import React from 'react';
import { LocationPage } from './useLocationPage';
import './useLocationPage.css';

// ─── Images ───────────────────────────────────────────────────────────────────
// Swap out any of these for Sarasota-specific shots
import heroImg   from '../images/tampa3.webp';
import bgImg     from '../images/image8.webp';
import slideImg1 from '../images/image121.webp';
import slideImg2 from '../images/image117.webp';
import slideImg3 from '../images/image50.webp';

// ─── Config ───────────────────────────────────────────────────────────────────
const palmaCeiaWestConfig = {

  /* ── SEO ────────────────────────────────────────────────────────────────── */
  pageTitle:       'Palma Ceia West Tree Service | Sam\'s Tree Service',
  metaDescription: 'Expert tree trimming and removal in Palma Ceia West, FL. Sam\'s Tree Service handles dangerous trees safely and professionally.',
  canonicalUrl:    'https://samstreeservice.com/tree_service_palma_ceia_west',

  /* ── Hero ───────────────────────────────────────────────────────────────── */
  heroHeading: 'Serving Palma Ceia West',
  heroImageUrl: heroImg,
  bgImageUrl:   bgImg,

  /* ── Slide images ───────────────────────────────────────────────────────── */
  slideImage1: slideImg1,
  slideImage2: slideImg2,
  slideImage3: slideImg3,

  /* ── Main text panel ────────────────────────────────────────────────────── */
  sectionHeading: 'Professional Tree Service in Palma Ceia West Specializing In Dangerous Trees',

  paragraphs: [
    `At <strong>Sam's Tree Service</strong>, we serve the attractive South Tampa 
     neighborhood of <strong>Palma Ceia West</strong> with professional tree care 
     that meets the standards of this sought after community. Beautiful mature 
     trees shade the homes and streets here and keeping them safe requires 
     expert trimming and management. Overhanging limbs, storm damage, and 
     structural decay don't wait for a convenient time, and neither do we.`,

    `We specialize in <strong>precision tree removal and trimming on quality 
     residential properties</strong> careful canopy work near premium homes 
     and landscaping, storm damaged limbs requiring prompt attention, large 
     overhangs near pools and outdoor living spaces, and full removals done 
     cleanly without disrupting the rest of your yard.`,

    `<strong>Sam's Tree Service</strong> delivers trusted, professional tree care 
     throughout <strong>Palma Ceia West</strong> and the surrounding 
     <strong>South Tampa</strong> neighborhoods maintaining the safety 
     and beauty of your property all year long.`,
  ],
  ctaLabel: 'Get a Free Estimate!',

  /* ── Service buttons (optional — defaults to the 4 standard ones) ────────── */
  // serviceButtons: [
  //   { label: 'Tree Trimming', to: '/tree_trimming' },
  //   { label: 'Tree Removal',  to: '/tree_removal'  },
  //   { label: 'Stump Removal', to: '/stump_removal'  },
  //   { label: 'Debris Hauling',to: '/debris_hauling' },
  // ],

  /* ── Google Map ─────────────────────────────────────────────────────────── */
  mapCity: 'Palma Ceia West, FL',
};

// ─── Page ─────────────────────────────────────────────────────────────────────
const Services_PalmaCeiaWest = () => <LocationPage config={palmaCeiaWestConfig} />;
export default Services_PalmaCeiaWest;
